export const MOBILE_WIDTH = 600;
export const TABLET_WIDTH = 988;
export const DESKTOP_WIDTH = 1100;
export const HEADER_HEIGHT = 95;
export const FOOTER_HEIGHT = 175;
